import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useLplModel } from "../lplModel";
import { ILplDetail } from "../lplService";
import useNavModel from "@/model/navModel";
import { useSalesDetailModel } from "@/views/sales/view/details/salesDetailModel";


export function DataTable() {
    const {
        dataSource, pgCfg, loading,
        loadData, setDialog, setNoteDialog
    } = useLplModel();
    const { addNav, replaceNav } = useNavModel(() => []);
    const { updateFormVal } = useSalesDetailModel(() => []);
    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ILplDetail> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'realCode',
            fixed: "left",
            ellipsis: true,
            render: (t, r) => <span className="label-span" onClick={() => { updateFormVal("edit", null); t && replaceNav("6-1", "3-2", { id: r.code, mode: "edit" }, true) }}>{t}</span>
        }, {
            title: '签订日期',
            width: 160,
            dataIndex: 'offerTime',
            render: t => t ? t.substring(0, 10) : t
        }, {
            title: '询价单号',
            width: 110,
            align: "center",
            dataIndex: 'inquiryCode',
            render: (t: string | undefined, r) => <span className="label-span" onClick={() => setDialog("inquire", true, r.inquiryId)}>{t}</span>
        }, {
            title: '报价单号',
            width: 110,
            align: "center",
            dataIndex: 'offerCode',
            render: (t: string | undefined, r) => <span className="label-span" onClick={() => setDialog("offer", true, r.offerId)}>{t}</span>
        }, {
            title: '采购合同号',
            width: 150,
            align: "center",
            dataIndex: 'purchaseCode',
            render: (t: string | undefined) => <span className="label-span" onClick={() => setDialog("purchase", true, t)}>{t}</span>
        },
        // {
        //     title: '入库日期',
        //     width: 160,
        //     dataIndex: 'deliveryInTime',
        // }, {
        //     title: '出库日期',
        //     width: 160,
        //     dataIndex: 'deliveryTime',
        // }, 
        {
            title: '订舱日期',
            width: 160,
            dataIndex: 'bookingTime', //待确认
        }, {
            title: '装柜日期',
            width: 180,
            dataIndex: 'carryTime',
        }, {
            title: '报关日期',
            width: 160,
            dataIndex: 'declareTime',//待确认
        }, {
            title: '海关放行日期',
            width: 160,
            dataIndex: 'releaseTime',
        }, {
            title: '装船日期',
            width: 160,
            dataIndex: 'shipmentTime',
        }, {
            title: '提单日期',
            width: 160,
            dataIndex: 'ladingTime',
        }, {
            title: '收回日期',
            width: 160,
            dataIndex: 'backTime',
        },
        //  {
        //     title: '交单日期',
        //     width: 160,
        //     dataIndex: 'presentationTime',
        // }, {
        //     title: '清关日期',
        //     width: 160,
        //     dataIndex: 'clearTime',
        // }, {
        //     title: '入库日期',
        //     width: 160,
        //     dataIndex: 'inDeliveryTime',
        // }, 
        // {
        //     title: '备注',
        //     width: 80,
        //     align: "center",
        //     render: (t, r) => <span className="label-span" onClick={() => setNoteDialog({ visible: true, row: r })}>详情</span>
        // }, 
        {
            title: '审批进程',
            width: 80,
            align: "center",
            render: (t, r) => <span className="label-span" onClick={() => addNav("6-1-1", { id: r.code, mode: "edit" })}>详情</span>
        }
    ];


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
